module.exports = __webpack_public_path__ + "officialStatic/img/xPartner1.16a6090.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/xplan/xPartner1.png
// module id = +GEe
// module chunks = 0